import { AccessGroupsFilter } from "./AccessGroupsFilter";
import type { ActivityScoreFilterProps } from "./ActivityScoreFilter";
import { ActivityScoreFilter } from "./ActivityScoreFilter";
import { AvatarSet } from "./AvatarSet";
import { BioFilter } from "./BioFilter";
import { EmailFilter } from "./EmailFilter";
import { EmailMarketingFilter } from "./EmailMarketingFilter";
import { EventsFilter } from "./EventsFilter";
import { GeoLocationFilter } from "./GeoLocationFilter";
import { HasPastDueSubscriptionFilter } from "./HasPastDueSubscriptionFilter";
import { HeadlineFilter } from "./HeadlineFilter";
import { InvitationLinksFilter } from "./InvitationLinksFilter";
import { InvitationStatusFilter } from "./InvitationStatusFilter";
import { InvitedAtDaysAgoFilter } from "./InvitedAtDaysAgoFilter";
import { JoinedCommunityDaysAgoFilter } from "./JoinedCommunityDaysAgoFilter";
import { LastLoggedInDaysAgoFilter } from "./LastLoggedInDaysAgoFilter";
import { LevelFilter } from "./LevelFilter";
import { LocationFilter } from "./LocationFilter";
import { MemberFilter } from "./MemberFilter";
import { NameFilter } from "./NameFilter";
import { PaywallsFilter } from "./PaywallsFilter";
import { RoleFilter } from "./RoleFilter";
import { SegmentFilter } from "./SegmentFilter/SegmentFilter";
import { SpaceGroupsFilter, SpaceGroupsFilterV2 } from "./SpaceGroupsFilter";
import { SpacesFilter } from "./SpacesFilter";
import { StatusFilter } from "./StatusFilter";
import { MemberTagsFilter } from "./TagsFilter";

export const SharedFilters = {
  AvatarSet,
  RoleFilter,
  SpaceGroupsFilter,
  SpaceGroupsFilterV2,
  SpacesFilter,
  StatusFilter,
  MemberTagsFilter,
  PaywallsFilter,
  EventsFilter,
  HasPastDueSubscriptionFilter,
  JoinedCommunityDaysAgoFilter,
  LastLoggedInDaysAgoFilter,
  ActivityScoreFilter,
  NameFilter,
  HeadlineFilter,
  BioFilter,
  LocationFilter,
  EmailFilter,
  InvitationLinksFilter,
  LevelFilter,
  GeoLocationFilter,
  MemberFilter,
  EmailMarketingFilter,
  InvitationStatusFilter,
  InvitedAtDaysAgoFilter,
  SegmentFilter,
  AccessGroupsFilter,
} as const;

export type { ActivityScoreFilterProps };
